import { writable } from 'svelte/store';

export const diff = writable({ added: [], modified: [], removed: [] });
export const diffLoading = writable(true);
export const elementSource = writable(null);
export const elementTarget = writable(null);
export const activityVersionId = writable(0);

export const selectedElement = writable(null);
export const readOnly = writable(false);
export const showFiori = writable(false);
export const isAPM = writable(false);
export const fioriComplete = writable(false);
export const isRequestNumberValid = writable(true);
export const allRequestNumbers = writable([]);
export const isD2Enabled = writable(false);

export const approvalInfo = writable({});
export const approvalDecision = writable(false);

export const targetComments = writable({});
export const riskSummaryRoles = writable([]);
